import React from 'react';

import Icon from '../../../components/AppIcon';

const steps = [
  { step: 'Signed Up', users: 1240, pct: 100, color: '#107570' },
  { step: 'Verified Email', users: 1054, pct: 85, color: '#0d9488' },
  { step: 'Created First Form', users: 807, pct: 65, color: '#14b8a6' },
  { step: 'Published Form', users: 558, pct: 45, color: '#2dd4bf' },
  { step: 'Got Submission', users: 384, pct: 31, color: '#5eead4' },
  { step: 'Invited Team', users: 186, pct: 15, color: '#99f6e4' },
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload?.length) {
    const d = payload?.[0]?.payload;
    return (
      <div className="bg-popover border border-border rounded-lg p-3 shadow-lg text-xs">
        <p className="font-semibold text-foreground mb-1">{d?.step}</p>
        <p className="text-muted-foreground">{d?.users?.toLocaleString()} users</p>
        <p className="text-primary font-medium">{d?.pct}% completion</p>
      </div>
    );
  }
  return null;
};

const OnboardingFunnel = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-sm font-semibold text-foreground">Onboarding Funnel</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Step-by-step completion rates</p>
        </div>
        <div className="flex items-center gap-1.5 px-2.5 py-1 bg-primary/10 rounded-full">
          <Icon name="TrendingUp" size={12} color="#107570" />
          <span className="text-xs font-medium text-primary">+4.2% this week</span>
        </div>
      </div>
      {/* Funnel bars */}
      <div className="space-y-2 mb-4">
        {steps?.map((s, i) => (
          <div key={s?.step} className="flex items-center gap-3">
            <span className="text-xs text-muted-foreground w-28 shrink-0 truncate">{s?.step}</span>
            <div className="flex-1 h-7 bg-muted rounded-md overflow-hidden relative">
              <div
                className="h-full rounded-md flex items-center px-2 transition-all duration-500"
                style={{ width: `${s?.pct}%`, backgroundColor: s?.color }}
              >
                <span className="text-xs font-semibold text-white whitespace-nowrap">{s?.pct}%</span>
              </div>
            </div>
            <span className="text-xs text-muted-foreground w-14 text-right shrink-0">
              {s?.users?.toLocaleString()}
            </span>
            {i > 0 && (
              <span className="text-xs text-error w-10 text-right shrink-0">
                -{steps?.[i - 1]?.pct - s?.pct}%
              </span>
            )}
            {i === 0 && <span className="w-10 shrink-0" />}
          </div>
        ))}
      </div>
      <div className="pt-3 border-t border-border flex items-center justify-between">
        <span className="text-xs text-muted-foreground">Overall completion rate</span>
        <span className="text-sm font-bold text-primary">15%</span>
      </div>
    </div>
  );
};

export default OnboardingFunnel;
